<template>
    <div class="well mt-3">
        <div class="flex-level">
            <h3 class="mt-0">
                {{
                    $l10n.__('%(appName)s - %(appVisibility)s', {
                        appName: consumer.consumer_i_app_name,
                        appVisibility: visibility,
                    })
                }}
            </h3>

            <span class="m-3 flex-row baseline flex-item-right">
                <link-button @clicked="deleteApp" class="mr-3">
                    <span class="red hover-alert-100">
                        {{ $l10n.__('Supprimer') }}
                    </span>
                </link-button>
                <link-button @clicked="editApp">
                    {{ $l10n.__('Modifier') }}
                </link-button>
            </span>
        </div>

        <div class="flex-level flex-top ovy-auto">
            <section class="flex flex-2">
                <div class="br-1">
                    <div class="info info mt-2 my-1">
                        <span class="info-label">
                            {{ $filters.capitalize($l10n.__('consumer token')) }} :
                        </span>
                        <span class="info-value">
                            {{ consumer.consumer_token }}
                        </span>
                    </div>

                    <div class="info info my-1">
                        <span class="info-label">
                            {{ $filters.capitalize($l10n.__('consumer secret')) }} :
                        </span>
                        <span class="info-value">{{ consumer.consumer_secret }}</span>
                    </div>

                    <div class="mt-4">
                        <link-button @clicked="regenToken('consumer', consumer.consumer_id)">
                            {{ $filters.capitalize($l10n.__('regénérer un token consumer')) }}
                        </link-button>
                    </div>
                </div>
            </section>
            <section class="flex flex-2 pl-3">
                <div class="br-1">
                    <div class="info info mt-2 my-1">
                        <span class="info-label">
                            {{ $filters.capitalize($l10n.__('utilisateur token')) }} :
                        </span>
                        <span class="info-value">{{ consumer.token_oauth_token }}</span>
                    </div>

                    <div class="info info my-1">
                        <span class="info-label">
                            {{ $filters.capitalize($l10n.__('utilisateur secret')) }} :
                        </span>
                        <span class="info-value">{{ consumer.token_oauth_secret }}</span>
                    </div>

                    <div class="mt-4">
                        <link-button
                            v-if="consumer.token_created_timestamp"
                            @clicked="regenToken('token', consumer.token_id)"
                        >
                            {{ $filters.capitalize($l10n.__('regénérer un token utilisateur')) }}
                        </link-button>
                        <link-button v-else @clicked="genToken">
                            {{ $filters.capitalize($l10n.__('générer un token utilisateur')) }}
                        </link-button>
                    </div>
                </div>
            </section>
            <section class="flex pl-3">
                <div>
                    <div class="info info my-1 mt-2">
                        <span class="fs-3 gray-60 pr-1">{{ $l10n.__("Niveau d'accès :") }} </span>
                        <span class="info-value">
                            <link-button @clicked="editVisibility">{{ visibility }}</link-button>
                        </span>
                    </div>
                    <div class="info info my-1 mt-2 flex-level">
                        <span class="fs-3 gray-60 pr-1">{{ $l10n.__('Créateur :') }} </span>
                        <span class="info-value">
                            <avatar-inline
                                :data="consumer.staff_info"
                                size="extra-small"
                                :wrapText="false"
                            ></avatar-inline>
                        </span>
                    </div>
                    <div class="info info my-1 mt-2">
                        <span class="fs-3 gray-60 pr-1">{{ $l10n.__('Date de création :') }} </span>
                        <span class="info-value">
                            {{ $filters.dateFormatter(consumer.created_at, 'NORMAL_DATE') }}
                        </span>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import LinkButton from 'vcomponents/utilities/LinkButton.vue';
import LegacyApi from 'api/api';
import AvatarInline from 'vcomponents/utilities/AvatarInline.vue';

export default {
    components: {
        LinkButton,
        AvatarInline,
    },
    props: {
        consumer: {
            type: Object,
            required: true,
        },
    },
    computed: {
        visibility() {
            switch (this.consumer.consumer_ispublic) {
                case 'Y':
                    return this.$l10n.__('Public');
                case 'N':
                    return this.$l10n.__('Privé');
                case 'W':
                    return this.$l10n.__('En attente de validation');
                case 'R':
                    return this.$l10n.__('Refusé');
            }
        },
    },
    methods: {
        editApp() {
            Api.genAppForm(this.consumer.consumer_id);
        },
        deleteApp() {
            Api.deleteApp(this.consumer.consumer_id);
        },
        editVisibility() {
            Api.editAccess(this.consumer.consumer_id);
        },
        genToken() {
            LegacyApi.genToken(this.consumer.consumer_id, this.consumer.consumer_mfownerid)
                .then((response) =>
                    this.updateToken('token', response.tokendata.token, response.tokendata.secret),
                )
                .catch((_) => {});
        },
        regenToken(type, id) {
            return this.$confirm(
                this.$l10n.__(
                    'Attention, en régénerant votre token vous devez le modifier dans le code de votre application.',
                ) +
                    ' ' +
                    this.$l10n.__('Êtes-vous sûr de vouloir continuer ?'),
                {
                    title:
                        type == 'consumer'
                            ? this.$l10n.__('Régénération du token consumer pour "%(appName)s"', {
                                  appName: this.consumer.consumer_i_app_name,
                              })
                            : this.$l10n.__(
                                  'Régénération du token utilisateur pour "%(appName)s"',
                                  { appName: this.consumer.consumer_i_app_name },
                              ),
                },
            )
                .then((_) => LegacyApi.regenToken(type, id))
                .then((response) => {
                    if (response.tokendata.error !== 'N') throw response.tokendata.error;
                    this.updateToken(
                        type,
                        response.tokendata.data.token,
                        response.tokendata.data.secret,
                    );
                })
                .catch((_) => {});
        },

        updateToken(type, token, secret) {
            switch (type) {
                case 'consumer':
                    this.consumer.consumer_token = token;
                    this.consumer.consumer_secret = secret;
                    break;
                case 'token':
                    this.consumer.token_oauth_token = token;
                    this.consumer.token_oauth_secret = secret;
                    this.consumer.token_created_timestamp = new Date().getTime();
                    break;
            }
        },
    },
};
</script>
